import React from "react";
import { Select } from "antd";
import { useCommonStore } from "@/store/useCommonStore";

const { Option } = Select;

const EntityRoleSelect = ({ value, onChange, className, multiple = true }) => {
    const data = useCommonStore.use.rolelist();
    const handleChange = (selectedValues, options) => {
        if (onChange) {
            if (multiple) {
                // 多选模式：返回完整的角色实体数组
                const entities = Array.isArray(options) ? options.map(opt => {
                    const roleData = data.find(role => role.Id === opt.value);
                    return roleData ? {
                        Id: roleData.Id,
                        Name: roleData.Name,
                        Description: roleData.Description,
                        Code: roleData.Code
                    } : null;
                }).filter(Boolean) : [];
                onChange(entities);
            } else {
                // 单选模式：返回完整的角色实体对象
                const roleData = data.find(role => role.Id === selectedValues);
                const entity = roleData ? {
                    Id: roleData.Id,
                    Name: roleData.Name,
                    Description: roleData.Description,
                    Code: roleData.Code
                } : null;
                onChange(entity);
            }
        }
    };

    // 处理value显示：如果value是实体对象，需要转换为ID用于Select组件
    const getDisplayValue = () => {
        if (!value) return undefined;
        
        if (multiple) {
            return Array.isArray(value) ? value.map(item => 
                typeof item === 'object' ? item.Id : item
            ) : [];
        } else {
            return typeof value === 'object' ? value.Id : value;
        }
    };

    const options = data.map(role => (
        <Option value={role.Id} key={role.Id}>
            {role.Name}
        </Option>
    ));

    return (
        <Select
            className={className || "w-full"}
            placeholder="请选择角色..."
            mode={multiple ? "multiple" : undefined}
            value={getDisplayValue()}
            onChange={handleChange}
        >
            {options}
        </Select>
    );
};

export default EntityRoleSelect;